module.exports = __webpack_public_path__ + "img/infographics_2.55eccfbc.png";